__turbopack_context__.v({
  "negative": "PercentChange-module__yYflYq__negative",
  "positive": "PercentChange-module__yYflYq__positive",
  "root": "PercentChange-module__yYflYq__root",
});
